import { render } from "./Skills.vue?vue&type=template&id=96465cd2&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=96465cd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-96465cd2"

export default script